import './services_single.scss';

const body = document.querySelector('.service_links_body');
if (body) init_scroll_indicator(body);

function init_scroll_indicator(body) {
	const list = body.querySelector('.service_links_list');
	const thumb = body.querySelector('.service_links_thumb');
	if (!list || !thumb) return;

	const update = () => {
		const ratio = list.clientHeight / list.scrollHeight;

		// Everything fits — no scroll indicator needed
		if (ratio >= 1) {
			body.classList.add('no_scroll');
			return;
		}
		body.classList.remove('no_scroll');

		const thumb_pct = Math.max(ratio * 100, 12);
		const max_scroll = list.scrollHeight - list.clientHeight;
		const top_pct = (list.scrollTop / max_scroll) * (100 - thumb_pct);

		thumb.style.height = thumb_pct + '%';
		thumb.style.top = top_pct + '%';
	};

	update();
	list.addEventListener('scroll', update, { passive: true });
	window.addEventListener('resize', update);
}
